<template>
  <div v-if="serviceData.length>0">
    <h3 class="p-t-10">服务费</h3>
    <Table  stripe size="small" :columns="serviceColumns" :data="serviceData" border disabled-hover :span-method="handleProductSpan" />
    <Row class="p-t-5">
      <i-col span="24" class="text-right p-r-20">
        服务费合计：{{serviceSummary}}
      </i-col>
    </Row>
  </div>
</template>

<script>
import { toMoney } from '@/utils/wnumb_own'
import { GetCurrentSchedule } from '@/utils/dateFormat'
import { getItemTypePriceList } from '@/api/order/orderserviceV2'

export default {
  data () {
    return {
      serviceColumns: [
        { title: '发布档期', key: 'schedule' },
        { title: '媒体类型', key: 'productName' },
        {
          title: '服务内容',
          render: (h, data) => {
            return h('span', data.row.typeName + ' - ' + data.row.name)
          }
        },
        { title: '服务单价', key: 'price' },
        { title: '采购数量', key: 'quantity' },
        { title: '服务费小计', align: 'right', key: 'totalPrice' }
      ],
      serviceData: [],
      scheduleColumSpan: [],
      mediumTypeColumSpan: [],

      serviceSummary: 0
    }
  },
  methods: {
    initPrice (orderId) {
      getItemTypePriceList({ orderId: orderId }).then(res => {
        this.serviceData = []
        let summary = 0

        res.forEach(element => {
          element.purchasedServiceitemList.forEach(item => {
            this.serviceData.push({
              schedule: GetCurrentSchedule(element.startDate, element.endDate),
              productId: element.productId,
              productName: element.productName,
              name: item.name,
              typeName: item.typeName,
              price: toMoney(item.price),
              quantity: item.quantity,
              totalPrice: toMoney(item.totalPrice)
            })
            summary += item.totalPrice
          })
        })

        this.serviceSummary = toMoney(summary)
        this.$emit('summaryPrice', summary)
        this.formatTable()
      })
    },
    formatTable () { // 格式化表格，预算出需要合并显示的列
      let exsitSchedule = null
      let exsitMedium = null
      this.scheduleColumSpan = []
      this.mediumTypeColumSpan = []

      for (let index = 0; index < this.serviceData.length; index++) {
        // 获取合并的档期项
        exsitSchedule = this.scheduleColumSpan.find(x => x.schedule === this.serviceData[index].schedule)
        if (exsitSchedule) {
          exsitSchedule.end += 1
        } else {
          this.scheduleColumSpan.push({
            schedule: this.serviceData[index].schedule,
            start: index,
            end: index + 1
          })
        }

        // 获取合并的媒体类型项
        exsitMedium = this.mediumTypeColumSpan.find(m => m.productId === this.serviceData[index].productId && m.schedule === this.serviceData[index].schedule)
        if (exsitMedium) {
          exsitMedium.end += 1
        } else {
          this.mediumTypeColumSpan.push({
            productId: this.serviceData[index].productId,
            productName: this.serviceData[index].productName,
            schedule: this.serviceData[index].schedule,
            start: index,
            end: index + 1
          })
        }
      }
    },
    handleProductSpan ({ row, column, rowIndex, columnIndex }) {
      // 档期列合并
      if (columnIndex === 0) {
        for (let index = 0; index < this.scheduleColumSpan.length; index++) {
          if (rowIndex === this.scheduleColumSpan[index].start) {
            return [this.scheduleColumSpan[index].end - this.scheduleColumSpan[index].start, 1]
          } else if (rowIndex < this.scheduleColumSpan[index].end) {
            return [0, 0]
          }
        }
      }

      // 媒体类型列合并
      if (columnIndex === 1) {
        for (let index = 0; index < this.mediumTypeColumSpan.length; index++) {
          if (rowIndex === this.mediumTypeColumSpan[index].start) {
            return [this.mediumTypeColumSpan[index].end - this.mediumTypeColumSpan[index].start, 1]
          } else if (rowIndex < this.mediumTypeColumSpan[index].end) {
            return [0, 0]
          }
        }
      }
    }
  }
}
</script>
